import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//improrts
import fr from './locale/fr.json'
import en from './locale/en.json'
import es from './locale/es.json'
import tr from './locale/tr.json'
import it from './locale/it.json'
import de from './locale/de.json'
import ar from './locale/ar.json'
import ja from './locale/ja.json'
//



i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            de: { translation: de },
            tr: { translation: tr },
            it: { translation: it },
            es: { translation: es },
            ar: { translation: ar },
            ja: { translation: ja },
        },
        debug: false, // if you're using a language detector, do not define the lng option
        fallbackLng: "en",
        keySeparator: ':',
        interpolation: {
            prefix: '%',
            suffix: '%',
        },
    });

export default i18n